module.exports = __webpack_public_path__ + "static/img/left_top_arrow.084ad6b5.svg";